import styled from "styled-components";
import Spring from "../../../components/Spring";

export const StyledNav = styled.nav`
    background-color: ${p => p.theme.c.boost};
    height: 50px;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    box-shadow: 0 0 10px 0 ${p => p.theme.c.blackShadow3};
    z-index: 100;
    transition: height 400ms;
`;

export const NavSpring = styled(Spring)`
    display: flex;
    height: 100%;
    padding: 0 12px;
    position: relative;
`;